
import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { Button } from '@/components/ui/button';

const FAQ = () => {
  const faqItems = [
    {
      question: "What's included in the Basic Course?",
      answer: "The Basic Course includes all foundational materials and worksheets. This is perfect for beginners who want to get started with the core concepts."
    },
    {
      question: "How does the Course + Bonus package work?",
      answer: "The Course + Bonus package includes everything in the Basic Course plus additional bonus materials, AI Development Swipe File and 100 AI Development prompts. This is our most popular option as it provides significantly more value for a small additional investment."
    },
    {
      question: "What will I get with the Premium Offer?",
      answer: "The Premium Offer includes lifetime access to the course and bonus materials, plus premium course materials and priority email support. This is ideal for those who want comprehensive training and resources with no time constraints."
    },
    {
      question: "What makes the Advanced Program worth $497?",
      answer: "The Advanced Program includes everything from previous tiers plus advanced strategies, and a personal implementation plan. This hands-on approach helps ensure your success through personalized guidance and accountability."
    },
    {
      question: "How does the Done For You service work?",
      answer: "Our Done For You service provides complete implementation by our expert team. After purchase, you'll have a strategy call with our team who will create a custom plan based on your specific needs. Our specialists will then implement everything for you, saving you time and ensuring professional results."
    },
    {
      question: "Can I upgrade my membership later?",
      answer: "Yes, you can upgrade your membership at any time. You'll only pay the difference between your current plan and the new one. We make it easy to scale up as your needs grow."
    },
    {
      question: "How long will I have access to the course materials?",
      answer: "Access duration is unlimited for all courses available with our program. You can access your course at anytime 24/7 forever!"
    },
    {
      question: "Is there a money-back guarantee?",
      answer: "Yes, we offer a 30-day money-back guarantee for all our courses and programs. If you're not satisfied with your purchase, contact our support team within 30 days of purchase for a full refund."
    },
    {
      question: "How is the content delivered?",
      answer: "All course content is delivered through our online membership portal. You'll have immediate access to all materials included in your membership tier as soon as your purchase is complete. For the Done For You service, you'll also receive personalized deliverables based on your strategy call."
    },
    {
      question: "What support options are available?",
      answer: "Support includes standard email support. Premium Offer includes priority email support, Advanced Program includes group coaching calls, and Done For You includes VIP support with a dedicated account manager."
    }
  ];

  return (
    <div className="container mx-auto px-4 py-12">
      <div className="text-center mb-12">
        <h1 className="text-3xl font-bold text-gray-900 md:text-4xl">
          Frequently Asked Questions
        </h1>
        <div className="w-24 h-1 bg-orange-500 mx-auto mt-4 mb-4"></div>
        <p className="mt-4 text-xl text-gray-600 max-w-2xl mx-auto">
          Find answers to common questions about our membership plans and services.
        </p>
      </div>
      
      <div className="max-w-3xl mx-auto">
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <Accordion type="single" collapsible className="w-full">
            {faqItems.map((item, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`} 
                className="border-b border-gray-100 last:border-0 px-6"
              >
                <AccordionTrigger className="text-left font-medium text-lg py-4 hover:text-orange-500">
                  {item.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 pb-4 text-left">
                  {item.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
        
        <div className="mt-12 text-center bg-gradient-to-br from-gray-50 to-blue-50 p-8 rounded-xl shadow-md">
          <h2 className="text-xl font-semibold mb-4">Still have questions?</h2>
          <p className="text-gray-600 mb-6">
            Can't find the answer you're looking for? Please contact our support team.
          </p>
          <div className="max-w-xs mx-auto">
            <a href="mailto:support@applaunchai.com">
              <Button className="w-full bg-orange-500 hover:bg-orange-600 text-white py-2 px-4 rounded-md transition-colors">
                Contact Support
              </Button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;

